let professions;
export default professions = [
    { name: ' Property Actuarist' },
    { name: ' Traditional Acupuncturist' },
    { name: '2D Sketch Artist' },
    { name: '3D Modeller' },
    { name: '3D Sketch Artist' },
    { name: 'Academic Economist' },
    { name: 'Academic Institution Tour Guide' },
    { name: 'Academic Research Epidemiologist' },
    { name: 'Academic Researcher' },
    { name: 'Academic Surgeon' },
    { name: 'Accident & Trauma Surgeon' },
    { name: 'Accordionist' },
    { name: 'Accountants' },
    { name: 'Accounting Officer' },
    { name: 'Accounts Payable Clerk' },
    { name: 'Accounts Receiving Clerk' },
    { name: 'Acetate Upholsterer' },
    { name: 'Acrobat Performer' },
    { name: 'Actor' },
    { name: 'Actors/Actresses' },
    { name: 'Actress' },
    { name: 'Actuaries' },
    { name: 'Actuary' },
    { name: 'Acupressure Acupuncturist' },
    { name: 'Acupuncturists' },
    { name: 'Ad & Promo Writer' },
    { name: 'Addiction Worker' },
    { name: 'Adjustment Clerks' },
    { name: 'Administrative Assistant' },
    { name: 'Administrative Coordinator' },
    { name: 'Administrative Manager' },
    { name: 'Administrative Officer' },
    { name: 'Administrative Secretary' },
    { name: 'Administrative Services Managers' },
    { name: 'Administrative Workers' },
    { name: 'Adult Care Giver' },
    { name: 'Adult Ministry Director' },
    { name: 'Advertisement Photographer' },
    { name: 'Advertising and Promotions' },
    { name: 'Advertising Photographer' },
    { name: 'Aerobic Dancer' },
    { name: 'Aerobic Instructor' },
    { name: 'Aeronautical Drafter' },
    { name: 'Aerospace Aeronautical Engineer' },
    { name: 'Aerospace Engineer' },
    { name: 'Aesthetician' },
    { name: 'African Culture Historian' },
    { name: 'Afrobeat Dancer' },
    { name: 'Afrobeat Musician' },
    { name: 'Afrojuju Musician' },
    { name: 'Agents' },
    { name: 'Agricultural Economist' },
    { name: 'Agricultural Engineer' },
    { name: 'Agricultural Equipment Driver' },
    { name: 'Agricultural Extension Specialist' },
    { name: 'Agricultural Inspector' },
    { name: 'Agricultural Journalist' },
    { name: 'Agricultural Journalist and Blogger' },
    { name: 'Agricultural Machinery Engineer' },
    { name: 'Agricultural Pest Control Expert' },
    { name: 'Agricultural Produce Packer' },
    { name: 'Agricultural Product Engineer' },
    { name: 'Agricultural Products Distributor' },
    { name: 'Agricultural Resource Economist' },
    { name: 'Agricultural Salesperson' },
    { name: 'Agricultural Science Teacher' },
    { name: 'Agricultural Scientist' },
    { name: 'Agricultural Technician' },
    { name: 'Agricultural/Crop Engineer' },
    { name: 'Agriculture' },
    { name: 'Agriculturist' },
    { name: 'Agro Biochemist' },
    { name: 'Agro Biophysics' },
    { name: 'Agro Biotechnologist' },
    { name: 'Agrologist' },
    { name: 'Agronomist' },
    { name: 'Air Cargo Handler' },
    { name: 'Air Force Firefighter' },
    { name: 'Air Freight Forwarder' },
    { name: 'Air Traffic Controller' },
    { name: 'Air Travel' },
    { name: 'Aircraft & Avionics Equipment Mechanic' },
    { name: 'Aircraft & Avionics Technician' },
    { name: 'Aircraft & Mechanics Service Technician' },
    { name: 'Aircraft Body Repairer' },
    { name: 'Aircraft Engine Assembler' },
    { name: 'Aircraft Maintenance' },
    { name: 'Aircraft/Avionics Mechanic' },
    { name: 'Airfield Operations Specialist' },
    { name: 'Airline Crew Member' },
    { name: 'Airline Crew Officer' },
    { name: 'Airline Customer Service' },
    { name: 'Airline Customer Service agent' },
    { name: 'Airline Hospitality & Catering Specialist' },
    { name: 'Alase' },
    { name: 'Alcohol & Drug Rehabilitation Officer' },
    { name: 'All Event Photographer' },
    { name: 'Allergist' },
    { name: 'Allergist & Immunologist' },
    { name: 'Allergist and Immunologist' },
    { name: 'Alto Singer' },
    { name: 'Aluminium Sculptor' },
    { name: 'Amusement and Recreation Officers' },
    { name: 'Anaesthesia Technician' },
    { name: 'Anaesthesiologist' },
    { name: 'Android Mobile Phone Repairer' },
    { name: 'Anesthesiologist ' },
    { name: 'Angiologist' },
    { name: 'Animal Breeder' },
    { name: 'Animal Care & Service Worker' },
    { name: 'Animal Experts' },
    { name: 'Animal Farm Manager' },
    { name: 'Animal Physiologist' },
    { name: 'Animal Scientist' },
    { name: 'Animal Scientist (Animal Expert)' },
    { name: 'Animal Technician' },
    { name: 'Animal Trainer' },
    { name: 'Animation Artist' },
    { name: 'Animation Designer' },
    { name: 'Animation Lighting Artist' },
    { name: 'Animation/ Cartoon Director' },
    { name: 'Ankara Upholsterer' },
    { name: 'Announcers' },
    { name: 'Anthropologists and Archaeologists' },
    { name: 'Anthropology & Archaelogy Teacher' },
    { name: 'Apala Musician' },
    { name: 'Appraisers and Assessors ' },
    { name: 'Aqua-cultural Manager' },
    { name: 'Aquaculturist' },
    { name: 'Aquaralist' },
    { name: 'Aquarium Animals Seller' },
    { name: 'Aquatic Paramedic' },
    { name: 'Arbitrators and Mediators ' },
    { name: 'Architects' },
    { name: 'Architectural Designer' },
    { name: 'Architectural Drafter' },
    { name: 'Architectural Historian' },
    { name: 'Architectural Photographer' },
    { name: 'Archive Manager' },
    { name: 'Art & Drama Teacher' },
    { name: 'Art Director' },
    { name: 'Art Librarian' },
    { name: 'Art Painter' },
    { name: 'Art/Artistic Director' },
    { name: 'Artisanship Teacher' },
    { name: 'Artist Assistant' },
    { name: 'Artistic Director' },
    { name: 'Artists Agent' },
    { name: 'Artists Manager' },
    { name: 'Assistant Director' },
    { name: 'Assistant General Manager' },
    { name: 'Assisting Embalmer' },
    { name: 'Assisting Undertaker' },
    { name: 'Associate Editor' },
    { name: 'Associate Producer' },
    { name: 'Astronomer' },
    { name: 'ATM Maintenance Technician' },
    { name: 'Audio & Video Equipment Expert' },
    { name: 'Audio & Video Equipment Technicians' },
    { name: 'Audio (Technician)' },
    { name: 'Audio Technician' },
    { name: 'Audiologist' },
    { name: 'Auditing Clerk' },
    { name: 'Auditor Accountant' },
    { name: 'Auditors' },
    { name: 'Autistic Spectrum Specialist' },
    { name: 'Auto Claims Clerk' },
    { name: 'Auto Electrician' },
    { name: 'Automated Filling Machine Operator' },
    { name: 'Automotive  Service Mechanic ' },
    { name: 'Automotive Assembler' },
    { name: 'Automotive Body & Glass Repairer' },
    { name: 'Automotive Engineer' },
    { name: 'Automotive Engineering Technician' },
    { name: 'Automotive Service Technician' },
    { name: 'Automotive Technician' },
    { name: 'Aviation Workers' },
    { name: 'Avionics Technician' },
    { name: 'Bag Filler' },
    { name: 'Bag Sealer' },
    { name: 'Bakers' },
    { name: 'Bakery Chef' },
    { name: 'Ballroom Dancer' },
    { name: 'Banquet Captain' },
    { name: 'Barbers' },
    { name: 'Bariatric Surgeon' },
    { name: 'Baritone Singer' },
    { name: 'Bartenders' },
    { name: 'Baseball Umpire' },
    { name: 'Basketball Referee' },
    { name: 'Bass Singer' },
    { name: 'Bathroom Designer' },
    { name: 'Beam Ceiling Installer' },
    { name: 'Beautician' },
    { name: 'Beauty Blogger' },
    { name: 'Beauty makeup Artist' },
    { name: 'Beauty Professional' },
    { name: 'Beauty Writer Editor' },
    { name: 'Bed Bug Exterminator' },
    { name: 'Behavioral Therapist' },
    { name: 'Belly Dancer' },
    { name: 'Bench Workers' },
    { name: 'Benefit Administrator' },
    { name: 'Bespoke Tailor' },
    { name: 'Billboard Advert Marketer' },
    { name: 'Binder & Wrapper' },
    { name: 'Binders, Bindery Machinery & Binding Technicians' },
    { name: 'Bindery Machine Operator' },
    { name: 'Bindery Maker' },
    { name: 'Bindery Worker' },
    { name: 'Binding Machine Operator' },
    { name: 'Binding Machine Repairer' },
    { name: 'Bio Information Technician' },
    { name: 'Bio-technologist' },
    { name: 'Biochemical Engineer' },
    { name: 'Biofuels Processing Technician' },
    { name: 'Biographer' },
    { name: 'Bioinfomatist' },
    { name: 'Biological Engineer' },
    { name: 'Biological Science Teacher' },
    { name: 'Biological Technical' },
    { name: 'Biomass Plant Technician' },
    { name: 'Biomass Technician' },
    { name: 'Biomedical Engineer' },
    { name: 'Biophysical Engineer' },
    { name: 'Biro Sketch Artist' },
    { name: 'Blog Writer' },
    { name: 'Blogger' },
    { name: 'Blood Vessels Surgeon' },
    { name: 'Boat Tour Guide' },
    { name: 'Body & Face Painter' },
    { name: 'Body & Paint Shop Manager' },
    { name: 'Body Wax Specialist' },
    { name: 'Book Critic' },
    { name: 'Book Editor' },
    { name: 'Book Keeper' },
    { name: 'Bookbinder' },
    { name: 'Booking Coordinator' },
    { name: 'Bookkeeper' },
    { name: 'Border Custom Officer ' },
    { name: 'Border Force Officer' },
    { name: 'Borehole Drill Operator' },
    { name: 'Boring Machine Operator' },
    { name: 'Bottle Handling Operator' },
    { name: 'Box Packer' },
    { name: 'Boxing Coach' },
    { name: 'Boxing Referee' },
    { name: 'Brand & Identity Designer' },
    { name: 'Brand Identity Designer' },
    { name: 'Brand Journalist' },
    { name: 'Bread maker' },
    { name: 'Breakdancing Dancer' },
    { name: 'Bricklayer Labourer' },
    { name: 'Bridal Makeup Artist' },
    { name: 'Broadcast & Sound Engineering Technician' },
    { name: 'Broadcast Technician' },
    { name: 'Broadcast Technician & Specialist' },
    { name: 'Broadcast/Sound Engineering Technician' },
    { name: 'Broadcasters & Broadcasting Technicians' },
    { name: 'Bronze Sculptor' },
    { name: 'Budget Analyst' },
    { name: 'Building Engineer' },
    { name: 'Building Superintendent' },
    { name: 'Building Surveyor' },
    { name: 'Bulldozer Opearator' },
    { name: 'Bundle Packer' },
    { name: 'Business Delivery Courier' },
    { name: 'Business Economist' },
    { name: 'Business Lawyer' },
    { name: 'Business Studies Teacher' },
    { name: 'Butchers & Meat Cutters ' },
    { name: 'Cabinet Maker' },
    { name: 'Calligrapher' },
    { name: 'Calypso Musician' },
    { name: 'Camera & Photographic Equipment Repairer' },
    { name: 'Camera Operator Assistant ' },
    { name: 'Camera Operator/ Specialist' },
    { name: 'Camera Operators & Photographic Equipment Technicians ' },
    { name: 'Camera Technician' },
    { name: 'Camera(Technician)' },
    { name: 'Car Electrician' },
    { name: 'Car Hire Driver' },
    { name: 'Car Manufacturing Machinist' },
    { name: 'Car Painter' },
    { name: 'Car Washer' },
    { name: 'Cardiac Care Nurse' },
    { name: 'Cardiac Nurse' },
    { name: 'Cardiac Nurse Assistant' },
    { name: 'Cardiac Physiologist' },
    { name: 'Cardiothoracic Surgeon' },
    { name: 'Cardiovascular Technician' },
    { name: 'Career Advancement Coach' },
    { name: 'Career Counselor' },
    { name: 'Career Rehabilitators' },
    { name: 'Cargo Levellers' },
    { name: 'Cargo Train Conductor' },
    { name: 'Cargo Train Engineer' },
    { name: 'Cargo Travel Agent' },
    { name: 'Carpenter' },
    { name: 'Carpenters' },
    { name: 'Carpet Cleaner' },
    { name: 'Carton Wrapper' },
    { name: 'Cartoon Animator' },
    { name: 'Cartoon Designer' },
    { name: 'Cartoonists & Animators ' },
    { name: 'Cash Manager' },
    { name: 'Casting Machine Operator' },
    { name: 'Caterers' },
    { name: 'Catering Manager' },
    { name: 'Catering Server' },
    { name: 'Ceiling Installers' },
    { name: 'Celebrity Event Planner' },
    { name: 'Celebrity Makeup Artist' },
    { name: 'Celebrity Photographer' },
    { name: 'Cellophane Wrapper' },
    { name: 'Cementing/Gluing Machine Operator' },
    { name: 'Ceramic & Glass Craft Artist' },
    { name: 'Ceramic Artist' },
    { name: 'Ceramic Tiller' },
    { name: 'Cereal Scientist' },
    { name: 'Certified Auditor' },
    { name: 'CGI Art Director' },
    { name: 'Chartered Accountant' },
    { name: 'Chartered Auditor' },
    { name: 'Chauffeur Driver ' },
    { name: 'Chef (Owner)' },
    { name: 'Chefs & Cooks ' },
    { name: 'Chemical Applicator' },
    { name: 'Chemical Engineer' },
    { name: 'Chemical Technician' },
    { name: 'Chemistry Teacher' },
    { name: 'Chess Arbiter' },
    { name: 'Chief Editor' },
    { name: 'Chief Executive Officer {CEO}' },
    { name: 'Chief Executives & Operations Managers' },
    { name: 'Chief Finance Officer' },
    { name: 'Chief Financial Officer {CFO}' },
    { name: 'Chief Funeral Director' },
    { name: 'Chief Information Officer {CIO}' },
    { name: 'Chief Information Security Officer {CISO}' },
    { name: 'Chief Marketing Officer {CMO}' },
    { name: 'Chief Operating Officer {COO}' },
    { name: 'Chief Sustainability Officer {CSO}' },
    { name: 'Child Care Giver/ Nanny' },
    { name: 'Child Photographer' },
    { name: 'Child Protection & Rehabilitation Officer' },
    { name: 'Child Psychologist' },
    { name: 'Child Therapist' },
    { name: 'Childcare Workers' },
    { name: 'Children Animator' },
    { name: 'Children Librarian' },
    { name: 'Children Ministry Director' },
    { name: 'Children Surgeon' },
    { name: "Children's Book Illustrator" },
    { name: "Children's Football Coach" },
    { name: "Children's Librarian" },
    { name: 'Chiropractor' },
    { name: 'Choreographer' },
    { name: 'Choreographers & Dancers ' },
    { name: 'Christian Dancer' },
    { name: 'Christian Religion Educator' },
    { name: 'Christianity Historian' },
    { name: 'Church Interpreter' },
    { name: 'Church Worker' },
    { name: 'Church Youth Counsellor' },
    { name: 'Churn Driller' },
    { name: 'Cigarette Packer' },
    { name: 'Cinematographer ' },
    { name: 'Circus Performer' },
    { name: 'Citrus Fruit Packer' },
    { name: 'City Planner' },
    { name: 'Civil & Domestic Investigator' },
    { name: 'Civil Drafter' },
    { name: 'Civil Engineer' },
    { name: 'Civil Engineering Technician' },
    { name: 'Classical Antiquities Historian' },
    { name: 'Clay Sculptor' },
    { name: 'Cleaners & Domestic Workers' },
    { name: 'Clerical Officer' },
    { name: 'Client Relations Manager' },
    { name: 'Clinical Assistant' },
    { name: 'Clinical Laboratory Scientist' },
    { name: 'Clinical Laboratory Technologist' },
    { name: 'Clinical Molecular Technologist' },
    { name: 'Clinical Nurse' },
    { name: 'Clinical Pharmacist' },
    { name: 'Clinical Psychologist' },
    { name: 'Clinical Psychology Expert' },
    { name: 'Clinical Social Worker' },
    { name: 'Clinical Technician' },
    { name: 'Clinical Trial Research Epidemiologist' },
    { name: 'Clinician Dietician' },
    { name: 'Cloth Packer' },
    { name: 'Cloud Architect' },
    { name: 'Club Bartender' },
    { name: 'CNC Grinding Technician' },
    { name: 'CNC Machinist' },
    { name: 'Co-Pilot' },
    { name: 'Co-Producer' },
    { name: 'Coaches, Trainers, Agents & Job/Talent Scouts ' },
    { name: 'Coalmine Drill Operator ' },
    { name: 'coffin Maker' },
    { name: 'Cold truck Driver' },
    { name: 'Collage Artist' },
    { name: 'College Superintendent' },
    { name: 'Colon & Rectal Surgeon' },
    { name: 'Columnist' },
    { name: 'Combination Tool Machine Operator' },
    { name: 'Combination Welder & Fitter' },
    { name: 'Comedy Performer' },
    { name: 'Comic Book Illustrator' },
    { name: 'Comic Strip Cartoonist' },
    { name: 'Commercial Architect' },
    { name: 'Commercial Building Carpenter' },
    { name: 'Commercial Butcher' },
    { name: 'Commercial Cook' },
    { name: 'Commercial Credit Analyst' },
    { name: 'Commercial Dishwasher' },
    { name: 'Commercial Electrician' },
    { name: 'Commercial Kitchen Hand' },
    { name: 'Commercial Pastry Chef' },
    { name: 'Commercial Plumber' },
    { name: 'Commercial Presser' },
    { name: 'Commercial Vehicle Inspector' },
    { name: 'Commissioning Editor' },
    { name: 'Communication Studies Teacher' },
    { name: 'Community Pharmacist' },
    { name: 'Community Support Worker' },
    { name: 'Companion-Animal Veterinarian' },
    { name: 'Company Administrative Officer' },
    { name: 'Company Car Driver' },
    { name: 'Company Front Desk Executive' },
    { name: 'Company Front Desk Officer' },
    { name: 'Company Receptionist' },
    { name: 'Company Secretatry' },
    { name: 'Company Truck Driver' },
    { name: 'Competition Judge' },
    { name: 'Computational Scientist' },
    { name: 'Computer & IT Experts' },
    { name: 'Computer Forensic Investigator' },
    { name: 'Computer Programmer' },
    { name: 'Computer Science Teacher' },
    { name: 'Computer Scientist' },
    { name: 'Computer Systems Manager' },
    { name: 'Computer Systems Repairer' },
    { name: 'Concept Artist' },
    { name: 'Concert Promoter' },
    { name: 'Concierges' },
    { name: 'Conciliator' },
    { name: 'Conference Interpreter' },
    { name: 'Conga Player' },
    { name: 'Conservation Scientist' },
    { name: 'Conservator' },
    { name: 'Constitutional Lawyer' },
    { name: 'Constitutional Paralegal' },
    { name: 'Construction & Maintenance Electrician ' },
    { name: 'Construction Cost Estimation/Manager' },
    { name: 'Construction Driller' },
    { name: 'Construction Engineer' },
    { name: 'Construction Inspector' },
    { name: 'Construction Labourer' },
    { name: 'Construction Manager' },
    { name: 'Construction Site Cleaner' },
    { name: 'Construction Site Safety Manager' },
    { name: 'Construction Superintendent' },
    { name: 'Construction Workers' },
    { name: 'Construction/ Civil Labourer' },
    { name: 'Consulting Forester' },
    { name: 'Container Filler' },
    { name: 'Container Trucking Driver' },
    { name: 'Contemporary Dancer' },
    { name: 'Content Editor' },
    { name: 'Contract/Temporary Staffer' },
    { name: 'Contralto Singer' },
    { name: 'Cooks' },
    { name: 'Copper Pipe Fitter' },
    { name: 'Copy Editor' },
    { name: 'Copy Writers' },
    { name: 'Core Making Machine Operator' },
    { name: 'Coroner Investigator' },
    { name: 'Coroner Technician' },
    { name: 'Coroners' },
    { name: 'Corporate Caterer' },
    { name: 'Corporate Cleaner' },
    { name: 'Corporate Lawyer' },
    { name: 'Corporate Meeting Planner' },
    { name: 'Corporate Paralegal' },
    { name: 'Corporate Tailor' },
    { name: 'Correctional Activities Specialist' },
    { name: 'Correctional Officers & Jailers' },
    { name: 'Corrections Counselor' },
    { name: 'Cosmetologist' },
    { name: 'Cost Accountant' },
    { name: 'Costume Designer' },
    { name: 'Costume Director' },
    { name: 'Cotton Upholsterer ' },
    { name: 'Counsellors' },
    { name: 'Counter Tenor Singer' },
    { name: 'Country Musician' },
    { name: 'Couriers and Messengers' },
    { name: 'Court Interpreter' },
    { name: 'Courtroom Illustrator' },
    { name: 'Coved Ceiling Installer' },
    { name: 'CPA (Certified Public Accountant)' },
    { name: 'Craft Artists' },
    { name: 'Craft Maker' },
    { name: 'Crane Operator' },
    { name: 'Crate Liner' },
    { name: 'Creative Art Director' },
    { name: 'Creative Copywriter' },
    { name: 'Creative Writers' },
    { name: 'Credit & Collections Analyst' },
    { name: 'Credit Analysts' },
    { name: 'Credit Fund Analyst' },
    { name: 'Credit Manager' },
    { name: 'Credit Research Analyst' },
    { name: 'Crime Scene Investigator' },
    { name: 'Criminal Investigators and Special Agents ' },
    { name: 'Criminal Justice & Law Enforcement Teacher' },
    { name: 'Criminal Lawyer' },
    { name: 'Critical Care Nurses' },
    { name: 'Critical Care Nursing Assistant' },
    { name: 'Crop Farm Manager' },
    { name: 'Cryptosystem Engineer' },
    { name: 'Cuisine Caterer' },
    { name: 'Cultural & Ethnic Dancer' },
    { name: 'Cultural/Ethnic Performer' },
    { name: 'Curators' },
    { name: 'Custom Compliance Officer' },
    { name: 'Custom Officer' },
    { name: 'Customer Self Service' },
    { name: 'Customer Service Adjustment Clerks' },
    { name: 'Customer Service Representative ' },
    { name: 'Customs Appraiser' },
    { name: 'Customs Broker' },
    { name: 'Cutting & Slicing Machine Operator' },
    { name: 'Cyber & Computer Investigator' },
    { name: 'Cycling Official' },
    { name: 'Cytogenetic Technician' },
    { name: 'Dairist' },
    { name: 'Dairy Product Scientist' },
    { name: 'Dairy Products Scientist' },
    { name: 'Dance Acrobat' },
    { name: 'Dance Instructor' },
    { name: 'Dance Musician' },
    { name: 'Dance School Trainer' },
    { name: 'Dancehall/Ragga Dancer' },
    { name: 'Dancers' },
    { name: 'Dancing Pallbearer' },
    { name: 'Dancing Performer' },
    { name: 'Data Modelling Administrator' },
    { name: 'Data Scientist' },
    { name: 'Database Administrator' },
    { name: 'Database Administrators' },
    { name: 'Daycare Worker' },
    { name: 'Decorative Cakes Baker' },
    { name: 'Delicate Fabric Presser' },
    { name: 'Demolition Expert/Supervisor' },
    { name: 'Demolition Labourer' },
    { name: 'Dental Doctor' },
    { name: 'Dental Hygienist ' },
    { name: 'Dental Laboratory Technician' },
    { name: 'Dental Nurse' },
    { name: 'dental Surgeon' },
    { name: 'Dentist' },
    { name: 'Dentist Assistant' },
    { name: 'Dentists' },
    { name: 'Deputy Coroner' },
    { name: 'Dermatologist' },
    { name: 'Dermatology Doctor' },
    { name: 'Designers' },
    { name: 'Development Director' },
    { name: 'Developmental Editor' },
    { name: 'Diabetologist' },
    { name: 'Diamond Mine Driller' },
    { name: 'Diesel Engine Assembler' },
    { name: 'Diesel Service Mechanic' },
    { name: 'Diesel Service Technician' },
    { name: 'Dietician' },
    { name: 'Dieticians and Nutritionists    ' },
    { name: 'Dietitian' },
    { name: 'Digestive System Surgeon' },
    { name: 'Digital Artist' },
    { name: 'Digital Cartoonist' },
    { name: 'Digital Copywriter' },
    { name: 'Digital Librarian' },
    { name: 'Digital Marketing Specialist' },
    { name: 'Digital Sketch Artist' },
    { name: 'Director' },
    { name: 'Director Of photography' },
    { name: 'Directors \u2013 Stage, Motion Pictures, Television and Radio' },
    { name: 'Directors: Religious Activities and Education ' },
    { name: 'Disability Support & Service Officer' },
    { name: 'Disaster Epidemiologist' },
    { name: 'Disc Jockey (DJ)' },
    { name: 'Disco Musician' },
    { name: 'Dishwashers' },
    { name: 'Documentarian' },
    { name: 'Dog Breeder' },
    { name: 'Dog Trainer' },
    { name: 'Domestic Arbitrator' },
    { name: 'Domestic Cook' },
    { name: 'Domestic Staff Agent' },
    { name: 'Domestic/Family Caterer' },
    { name: 'Drafter (Architect)' },
    { name: 'Drafters' },
    { name: 'Drafting & Design Engineer' },
    { name: 'Dressmaker' },
    { name: 'Drilling & Boring Tool Operator' },
    { name: 'Drummer' },
    { name: 'Dry Cleaning Agent' },
    { name: 'Dry Cleaning Expert' },
    { name: 'Dry packaging Operator' },
    { name: 'Duplicating Machine Operator' },
    { name: 'Early Childhood Teacher' },
    { name: 'Earth Drillers' },
    { name: 'Economic Historian' },
    { name: 'Economics Teacher' },
    { name: 'Economists' },
    { name: 'Editorial & Informative Cartoonist' },
    { name: 'Editorial Illustrator' },
    { name: 'Editors' },
    { name: 'Education Administrators' },
    { name: 'Education Teacher' },
    { name: 'Education, Training, and Library Workers' },
    { name: 'Educational Consultant Psychologist' },
    { name: 'Educational Event Planner' },
    { name: 'Educational Psychologists' },
    { name: 'Educational Software Consultant' },
    { name: 'Effects Animator' },
    { name: 'Egg Caser' },
    { name: 'Egg Packer' },
    { name: 'Electric & Electronic Technician' },
    { name: 'Electrical & Electronic Engineering Technician' },
    { name: 'Electrical Assembler' },
    { name: 'Electrical Drafter' },
    { name: 'Electrical Engineer' },
    { name: 'Electrical Fencer/Erector' },
    { name: 'Electrical Parts Reconditioner' },
    { name: 'Electrical Power-Line Installer & Repairer' },
    { name: 'Electrician' },
    { name: 'Electricians' },
    { name: 'Electro Acupuncturist' },
    { name: 'Electronic Installer' },
    { name: 'Electronic Repairer' },
    { name: 'Electronics Engineer' },
    { name: 'Elementary School Teachers' },
    { name: 'Elementary Teaching Assistant' },
    { name: 'Elocution & Phonetics Teacher' },
    { name: 'Email Customer Service' },
    { name: 'Email Marketer' },
    { name: 'Embalmer' },
    { name: 'Embalmers' },
    { name: 'Emergency Medical Technician' },
    { name: 'Emergency Medical Technicians and Paramedics' },
    { name: 'Emergency Room Nurse' },
    { name: 'Emergency Room Nursing Assistant' },
    { name: 'Employment Agent' },
    { name: 'Employment Interviewer' },
    { name: 'Employment Lawyer' },
    { name: 'Employment, Recruitment, and Placement Specialists' },
    { name: 'EMT Firefighter' },
    { name: 'Endocrine Surgeon' },
    { name: 'Endocrinological Surgeon' },
    { name: 'Endocrinologist' },
    { name: 'Endoscopy Technician' },
    { name: 'Energy Engineer' },
    { name: 'Energy Optimization Engineer' },
    { name: 'Engine and Other Machine Assemblers' },
    { name: 'Engineering Studies Teacher ' },
    { name: 'Engineers' },
    { name: 'English & Literature Teacher' },
    { name: 'Engravers' },
    { name: 'Enterprise Risk Actuarist' },
    { name: 'Entertainers and Performers' },
    { name: 'Entertainment Lawyer ' },
    { name: 'Entomologist' },
    { name: 'Environmental Engineer' },
    { name: 'Environmental Science' },
    { name: 'Epidemiologists' },
    { name: 'Escort/Business Interpreter' },
    { name: 'Essayist' },
    { name: 'Estate Security' },
    { name: 'Etchers Hand Engraver' },
    { name: 'Etching Engraver' },
    { name: 'Ethnic & Cultural Studies Teacher ' },
    { name: 'Ethnic Dancer' },
    { name: 'Event Photographer' },
    { name: 'Event Planing Expert' },
    { name: 'Event planner' },
    { name: 'Event Planning Specialist' },
    { name: 'Events Cameraman' },
    { name: 'Evolutionary Scientist' },
    { name: 'Excavating & Loading Machine Operator' },
    { name: 'Excavator Operator' },
    { name: 'Excursion Guide' },
    { name: 'Executive Assistant' },
    { name: 'Executive Chef' },
    { name: 'Executive Producer' },
    { name: 'Executive Secretary' },
    { name: 'Exercise Physiologist' },
    { name: 'Exhibition Designer' },
    { name: 'Exhibitions Officer' },
    { name: 'Exotic Veterinarian' },
    { name: 'Expert Psychiatrist' },
    { name: 'Express Courier' },
    { name: 'Extension Forester' },
    { name: 'External Auditor' },
    { name: 'Extruding & Drawing Machine Operator' },
    { name: 'Eye Brow Shaping Expert' },
    { name: 'Eye Lash Extending Expert' },
    { name: 'Eye Surgeon' },
    { name: 'Face Painter' },
    { name: 'Facebook Broadcaster' },
    { name: 'Facility & Maintenance Manager' },
    { name: 'Facility Manager' },
    { name: 'Factory Manager' },
    { name: 'Family Counselor ' },
    { name: 'Family Doctor' },
    { name: 'Family Law Paralegal' },
    { name: 'Family Lawyer' },
    { name: 'Family Physician' },
    { name: 'Family/ General Physician' },
    { name: 'FAQ Customer Service' },
    { name: 'Farm Equipment Operator' },
    { name: 'Farm Labourer' },
    { name: 'Farm Maintenance Manager' },
    { name: 'Farm Manager' },
    { name: 'Farm Produce Quality Control Manager' },
    { name: 'Farm Worker' },
    { name: 'Farmers And Ranchers, Farm, Ranch, And Other Agricultural Managers' },
    { name: 'Fashion Catalogue' },
    { name: 'Fashion Designer' },
    { name: 'Fashion Designer/ Illustrator' },
    { name: 'Fashion Designer/ Seamstress' },
    { name: 'Fashion Designers' },
    { name: 'Fashion Event Photographer' },
    { name: 'Fashion Illustrator' },
    { name: 'Fashion Makeup Artist' },
    { name: 'Fashion Marketer' },
    { name: 'Fashion Model' },
    { name: 'Fashion Photographer' },
    { name: 'Fashion Retail Manager' },
    { name: 'Fashion Salesperson' },
    { name: 'Fashion Stylist' },
    { name: 'Fashion Visual Meechandiser' },
    { name: 'Federal Correctional Officer' },
    { name: 'Federal Investigator' },
    { name: 'Federal School Superintendent' },
    { name: 'Female Barber' },
    { name: 'Female Bartender' },
    { name: 'Female Drummer' },
    { name: 'Female Fashion Tailor' },
    { name: 'Female General Surgeon' },
    { name: 'Female Infertility' },
    { name: 'Female Model' },
    { name: 'Female Nanny' },
    { name: 'Fencing Expert' },
    { name: 'Fibre & Textile Craft Artist' },
    { name: 'Field Epidemiologist' },
    { name: 'Field Hockey Umpire' },
    { name: 'Field Judge' },
    { name: 'File Clerk (Administrative Worker)' },
    { name: 'File Clerks' },
    { name: 'Film & Video Editing Expert' },
    { name: 'Film and Video Editors' },
    { name: 'Film Development Executive' },
    { name: 'Film Hair Stylist' },
    { name: 'Film Laboratory Editor' },
    { name: 'Film Production Designer' },
    { name: 'Finance Actuarist' },
    { name: 'Finance Investigator' },
    { name: 'Finance Workers' },
    { name: 'Financial & Economic Planner' },
    { name: 'Financial Analyst' },
    { name: 'Financial Analysts' },
    { name: 'Financial Controller' },
    { name: 'Financial Examiners' },
    { name: 'Financial Managers' },
    { name: 'Financial Planner' },
    { name: 'Financial Secretary' },
    { name: 'Fine Art Illustrator' },
    { name: 'Fine Art Photographer' },
    { name: 'Fine Artists, Including Painters, Sculptors, And Illustrators' },
    { name: 'Fire & Hazard Investigator' },
    { name: 'Fire Inspector' },
    { name: 'Fire Investigator' },
    { name: 'Fire Safety and Protection Officials' },
    { name: 'Fire Sprinkler Pipe Fitter' },
    { name: 'Firefighter Engineer' },
    { name: 'Firefighter Paramedic' },
    { name: 'Fish & Game Warden' },
    { name: 'Fish Hatchery Manager' },
    { name: 'Fish Packer' },
    { name: 'Fisherman' },
    { name: 'Fitness and Wellness Coordinators' },
    { name: 'Fitness Instructor' },
    { name: 'Fitness Model' },
    { name: 'Flash Designer' },
    { name: 'Flavour Chemist' },
    { name: 'Flight Attendant' },
    { name: 'Flight Nurse' },
    { name: 'Flight/Air Ambulance Paramedic' },
    { name: 'Floor Polisher' },
    { name: 'Flooring Carpenter' },
    { name: 'Floral Designer' },
    { name: 'Flower Craft Artist' },
    { name: 'Food Biochemist' },
    { name: 'Food Cell Technician' },
    { name: 'Food Critic' },
    { name: 'Food Engineer' },
    { name: 'Food Handler' },
    { name: 'Food Historian' },
    { name: 'Food Industry R&D' },
    { name: 'Food Market Researcher' },
    { name: 'Food Microbiologist' },
    { name: 'Food Packaging Specialist' },
    { name: 'Food Packer' },
    { name: 'Food Product Consultant' },
    { name: 'Food Product Developer' },
    { name: 'Food Production Manager' },
    { name: 'Food Safety & Inspection Veterinarian' },
    { name: 'Food Safety Auditor' },
    { name: 'Food Science Technician' },
    { name: 'Food Scientist' },
    { name: 'Food Scientists and Technologists' },
    { name: 'Food Technologist' },
    { name: 'Food Technology Development Manager' },
    { name: 'Food Toxicologist' },
    { name: 'Food-Animal Veterinarian' },
    { name: 'Food/Cooking Machine Operator' },
    { name: 'Football Coach' },
    { name: 'Football Referee' },
    { name: 'Foreign Language & Literature Teacher' },
    { name: 'Foreign Language Translator' },
    { name: 'Foreman' },
    { name: 'Forensic Accountant' },
    { name: 'Forensic Animator' },
    { name: 'Forensic Artist' },
    { name: 'Forensic Auditor' },
    { name: 'Forensic Investigator' },
    { name: 'Forest Conservation Officer' },
    { name: 'Forest Fire Fighting & Prevention Specialist' },
    { name: 'Forest Fire Prevention Specialist' },
    { name: 'Forest Firefighter' },
    { name: 'Forester' },
    { name: 'Foresters' },
    { name: 'Forestry & Conservation Teacher' },
    { name: 'Forestry Scientist' },
    { name: 'Free Lawyer' },
    { name: 'Freelance Model' },
    { name: 'Freight and Cargo Inspectors' },
    { name: 'Freight Inspector' },
    { name: 'Front Desk Receptionist' },
    { name: 'Front Desk Receptionist/Cashier' },
    { name: 'Fuel Cell Engineer' },
    { name: 'Fuel Pump Attendant' },
    { name: 'Fuel Station Dealer' },
    { name: 'Fuel Station Manager' },
    { name: 'Fumigator' },
    { name: 'Fund Manager' },
    { name: 'Funeral Attendants' },
    { name: 'Funeral Director' },
    { name: 'Furniture Carpenter' },
    { name: 'Furniture Designer' },
    { name: 'Furniture Designer/Producer' },
    { name: 'Furniture Upholsterer' },
    { name: 'Gag Cartoonist' },
    { name: 'Game Writer' },
    { name: 'Gangan Player' },
    { name: 'Gas Appliance Repairer' },
    { name: 'Gas Pipe Fitter' },
    { name: 'Gas Plant Operator' },
    { name: 'Gas Plant Operators' },
    { name: 'Gas Retailer' },
    { name: 'Gastroenterologist' },
    { name: 'Gender Historian' },
    { name: 'General Bookkeeper' },
    { name: 'General Corrections Officer' },
    { name: 'General Curator' },
    { name: 'General Dentist' },
    { name: 'General ICU Nurse' },
    { name: 'General Machinist' },
    { name: 'General Maintenance Technician' },
    { name: 'General Manager' },
    { name: 'General Pest Control Expert' },
    { name: 'General Practitioner' },
    { name: 'General Repairer' },
    { name: 'General Surgeon' },
    { name: 'Generator Repairer' },
    { name: 'Genetic Counsellor' },
    { name: 'Geneticist' },
    { name: 'Geneticists' },
    { name: 'Geodetic Surveyor' },
    { name: 'Geographer' },
    { name: 'Geographic Inform Action Systems Technician' },
    { name: 'Geographical Teacher' },
    { name: 'Geography Teacher' },
    { name: 'Geological & Petroleum Technician' },
    { name: 'Geological Data Technician' },
    { name: 'Geological Engineer' },
    { name: 'Geological Sample Test Technician' },
    { name: 'Geological Technician' },
    { name: 'Geologists' },
    { name: 'Geophysicist' },
    { name: 'Geoscientist' },
    { name: 'Geothermal Operating Equipment Operator' },
    { name: 'Geriatric Nurse' },
    { name: 'Geriatric Nursing Assistant' },
    { name: 'Geriatric Physical Therapist' },
    { name: 'Gift Wrapper' },
    { name: 'Glass Artist' },
    { name: 'Glass Bender' },
    { name: 'Glass cutting Machine Operator' },
    { name: 'Glass Finisher' },
    { name: 'Glass Molders' },
    { name: 'Glaziers' },
    { name: 'Gospel Musician' },
    { name: 'Government Accountant' },
    { name: 'Government Auditor' },
    { name: 'Government Certified Trailer Inspector' },
    { name: 'Government Certified Vehicle Inspector' },
    { name: 'Government Economist' },
    { name: 'Government Paralegal' },
    { name: 'Grader Operator' },
    { name: 'Graduate Teaching Assistant' },
    { name: 'Grain packer' },
    { name: 'Graphic Designer' },
    { name: 'Graphic Designers' },
    { name: 'Greeting Card Illustrator' },
    { name: 'Grief Counselor' },
    { name: 'Grinding & Polishing Machine Operator' },
    { name: 'Grocery Packer' },
    { name: 'Group Fitness Instructor' },
    { name: 'Guard Rail Installer' },
    { name: 'Guitarist' },
    { name: 'Gym Instructor/Trainer' },
    { name: 'Gymnastics Judges' },
    { name: 'Gynaecologist' },
    { name: 'Hair Care Specialist' },
    { name: 'Hair Colorist' },
    { name: 'Hair Colourist' },
    { name: 'Hair Designer' },
    { name: 'Hair Designer Barber' },
    { name: 'Hair Model' },
    { name: 'Hairdressers' },
    { name: 'Hairstylist' },
    { name: 'Hand Model Maker' },
    { name: 'Handball Referee' },
    { name: 'Harpist' },
    { name: 'Hatchery Expert' },
    { name: 'Hausa Teacher' },
    { name: 'Head Chef' },
    { name: 'Headmaster' },
    { name: 'Headtie/ Gele Expert' },
    { name: 'Health & Safety Engineer' },
    { name: 'Health & Wellness Coach' },
    { name: 'Health Actuarist' },
    { name: 'Health Care Practitioners' },
    { name: 'Health Coach' },
    { name: 'Health Counselor' },
    { name: 'Health Educators' },
    { name: 'Health Specialties' },
    { name: 'Health Technicians and Technologists ' },
    { name: 'Hearse Driver' },
    { name: 'Heart Surgeon' },
    { name: 'Heavy Equipment Assessor' },
    { name: 'Heavy Equipment Operator' },
    { name: 'Heavy Equipment Operators' },
    { name: 'Heavy Equipment Technician' },
    { name: 'Heavy Vehicle Equipment Service Technician' },
    { name: 'Hepatologist' },
    { name: 'Herdsman' },
    { name: 'High Profile Event Planner' },
    { name: 'Highlife Musician' },
    { name: 'Highway Maintenance Workers' },
    { name: 'Hip Hip Dancer' },
    { name: 'Hip Hop Ballet Dancer' },
    { name: 'Hip hop Musician' },
    { name: 'Historians' },
    { name: 'History Teacher' },
    { name: 'Home Appliance Repairer' },
    { name: 'Home Care Aide' },
    { name: 'Home Decorator' },
    { name: 'Home Economics Teacher' },
    { name: 'Home Theater Installer/Technician' },
    { name: 'Horticulturist' },
    { name: 'Hospital Cook' },
    { name: 'Hospital Nurse Aide ' },
    { name: 'Hospital Pharmacist' },
    { name: 'Hospitalist' },
    { name: 'Hotel Chef' },
    { name: 'Hotel Desk Clerk' },
    { name: 'Hotel Detective' },
    { name: 'Hotel Dishwasher' },
    { name: 'Hotel Housekeeping Supervisor' },
    { name: 'Hotel Manager' },
    { name: 'Hotel Workers' },
    { name: 'House Cleaner' },
    { name: 'House Cleaning Company' },
    { name: 'House Housekeeper' },
    { name: 'House Keeper' },
    { name: 'House Maid' },
    { name: 'House Manager' },
    { name: 'House Painter' },
    { name: 'House/Domestic Cleaner' },
    { name: 'Housekeepers' },
    { name: 'Housekeeping Manager' },
    { name: 'Human Rights Paralegal' },
    { name: 'Humorous Illustrator' },
    { name: 'Hydroelectric Plant Technician' },
    { name: 'Igbo Teacher' },
    { name: 'Illustration Designer' },
    { name: 'Immigration Inspector' },
    { name: 'Immigration Inspectors' },
    { name: 'Immigration Interpreter' },
    { name: 'Immigration Lawyer' },
    { name: 'Immigration Paralegal' },
    { name: 'Immigration/International Lawyer' },
    { name: 'Immunologist' },
    { name: 'In Home Housekeeper' },
    { name: 'Indoor Pest Control Expert' },
    { name: 'Industrial Baker' },
    { name: 'Industrial Butcher' },
    { name: 'Industrial Camera Operator' },
    { name: 'Industrial Camera Repairer' },
    { name: 'Industrial Camera Technician' },
    { name: 'Industrial Carpenter' },
    { name: 'Industrial Caterer' },
    { name: 'Industrial Cook' },
    { name: 'Industrial Dishwasher' },
    { name: 'Industrial Electrician' },
    { name: 'Industrial Engineer' },
    { name: 'Industrial Engineering Technician' },
    { name: 'Industrial Forester' },
    { name: 'Industrial Machinery Maintenance Mechanic' },
    { name: 'Industrial Machinery Mechanics' },
    { name: 'Industrial Painter' },
    { name: 'Industrial Pipe Fitter' },
    { name: 'Industrial Product Designer' },
    { name: 'Industrial Sewing & Whipping Machine Operator  ' },
    { name: 'Industrial Staff Agent' },
    { name: 'Industrial Welder' },
    { name: 'Information Technology Workers' },
    { name: 'Innovation Manager' },
    { name: 'Insecticide Expert' },
    { name: 'Installation Administrator' },
    { name: 'Installation Maintenance and Repair Workers' },
    { name: 'Instructional Performer' },
    { name: 'Insurance' },
    { name: 'Insurance & Claim Investigator' },
    { name: 'Insurance Actuarist' },
    { name: 'Insurance Appraiser' },
    { name: 'Insurance Broker' },
    { name: 'Insurance Claims Officer' },
    { name: 'Insurance Investigator' },
    { name: 'Insurance Officer' },
    { name: 'Insurance Sales Marketer' },
    { name: 'Insurance Underwriter' },
    { name: 'Intellectual Property Lawyer' },
    { name: 'Intellectual Property Paralegal' },
    { name: 'Interior Decorator' },
    { name: 'Interior Designer' },
    { name: 'Interior Designers' },
    { name: 'Internal & External Auditor' },
    { name: 'Internal Auditor' },
    { name: 'Internal Revenue Agent' },
    { name: 'International Arbitrator' },
    { name: 'International Barber' },
    { name: 'International Delivery Courier' },
    { name: 'International Model' },
    { name: 'International Wedding Planner ' },
    { name: 'Internist' },
    { name: 'Internist Doctor' },
    { name: 'Interpreters and Translators ' },
    { name: 'Interstate Commercial Driver' },
    { name: 'Interstate Truck Driver' },
    { name: 'Investigating & Billing Clerk' },
    { name: 'Investment & Banking Analyst' },
    { name: 'Investment & Economic Analyst' },
    { name: 'Investment Accountant' },
    { name: 'Investment Actuarist' },
    { name: 'Investment Banker' },
    { name: 'Investment Banking Analyst' },
    { name: 'Investment Fund Manager' },
    { name: 'Iphone Mobile Repairer' },
    { name: 'Iron Bender' },
    { name: 'Iron Welder' },
    { name: 'iron Work Constructor' },
    { name: 'Iron Worker' },
    { name: 'Ironing Hand Presser' },
    { name: 'Islamic Dancer' },
    { name: 'Islamic Historian' },
    { name: 'Islamic religion Educator' },
    { name: 'IT Coordinator' },
    { name: 'IT Director' },
    { name: 'IT Manager' },
    { name: 'IT Security Specialist' },
    { name: 'IT Technical Specialist' },
    { name: 'IT Technician' },
    { name: 'Jade Sculptor' },
    { name: 'Janitor/Caretaker' },
    { name: 'Janitors and Cleaners' },
    { name: 'Java Developer' },
    { name: 'Jazz Dancer' },
    { name: 'Jazz Drummer' },
    { name: 'Jazz Musician' },
    { name: 'Jewelry Model & Mode Maker' },
    { name: 'Job Recruiter' },
    { name: 'Journalist' },
    { name: 'Journeyman Electrician' },
    { name: 'Juju Musician' },
    { name: 'Junior Tax Associate' },
    { name: 'Juvenile Correction Officer' },
    { name: 'Kabu-Kabu Driver' },
    { name: 'Keke Marwa Repairer' },
    { name: 'Keyboardist' },
    { name: 'Kitchen Architect/ Designer' },
    { name: 'Lab Technician' },
    { name: 'Laboratory Director' },
    { name: 'Laboratory Geneticist' },
    { name: 'Laboratory Technician' },
    { name: 'Laborers' },
    { name: 'Land & Geomatics Surveyor' },
    { name: 'Landscape Architect' },
    { name: 'Landscaper Electrical Engineer' },
    { name: 'Landscraper Labourer' },
    { name: 'Language Translator' },
    { name: 'Laptop Repair Technician' },
    { name: 'Large Animal Veterinarian' },
    { name: 'Large Surface Sketch Artist' },
    { name: 'Laser Acupuncturist' },
    { name: 'Laser Engraver' },
    { name: 'Laundry & Dry Cleaning Supervisor' },
    { name: 'Laundry and Dry-Cleaning Workers' },
    { name: 'Laundry Attendant' },
    { name: 'Laundry Man' },
    { name: 'Laundry/Dry Cleaning Machine Operator' },
    { name: 'Laundryman' },
    { name: 'Law Librarian' },
    { name: 'Law Studies Teacher' },
    { name: 'Lawyers' },
    { name: 'Layout Artist' },
    { name: 'Leather Upholsterer' },
    { name: 'Legal Assistant' },
    { name: 'Legal Investigator' },
    { name: 'Legal Secretary' },
    { name: 'Legal Support Workers' },
    { name: 'Lexicographer' },
    { name: 'Librarian ' },
    { name: 'Librarian Teacher' },
    { name: "Librarian's Assistant" },
    { name: 'Librarians' },
    { name: 'Library Assistant' },
    { name: 'Library Assistant Technician' },
    { name: 'Library Clerk' },
    { name: 'Library Director' },
    { name: 'Library Manager' },
    { name: 'Library Science Teacher' },
    { name: 'Library Technician' },
    { name: 'Library Tecnician' },
    { name: 'Library- Manager' },
    { name: 'Life Guard' },
    { name: 'Lifeguard' },
    { name: 'Light Equipment Assessor' },
    { name: 'Light Truck Driver' },
    { name: 'Lightening (Technician)' },
    { name: 'Lightening Technician' },
    { name: 'Lighting & Fittings Designer' },
    { name: 'lighting Designer' },
    { name: 'Lighting Designer/ Director' },
    { name: 'Lighting Technician' },
    { name: 'Limb & Extremeties Surgeon' },
    { name: 'Limousine Driver' },
    { name: 'Line Attendant' },
    { name: 'Line Cook' },
    { name: 'Line Judge' },
    { name: 'Line Producer' },
    { name: 'Linen Upholsterer' },
    { name: 'Linesman' },
    { name: 'Lingerie & Swimsuit Model' },
    { name: 'Litigation Paralegal' },
    { name: 'Live Chat Customer Service' },
    { name: 'Live in Housekeeper' },
    { name: 'Live out Housekeeper' },
    { name: 'Loading Machine Operator' },
    { name: 'Local & State Law Enforcement' },
    { name: 'Local Bartender' },
    { name: 'Local Cuisine Cook' },
    { name: 'Local Government Revenue Collector' },
    { name: 'Local Language Translator' },
    { name: 'Location Manager' },
    { name: 'Locksmith & Safe Repairer' },
    { name: 'Locomotive (train) Workers' },
    { name: 'Locomotive Engineer' },
    { name: 'Loctician' },
    { name: 'Logistics Engineer' },
    { name: 'Logo Designer' },
    { name: 'Lumberjack' },
    { name: 'Lyricist' },
    { name: 'Macbook Repair Specialist' },
    { name: 'Machine Operators' },
    { name: 'Machinery Maintenance Workers' },
    { name: 'Machinists' },
    { name: 'Mail Clerk' },
    { name: 'Maintenance Administrator' },
    { name: 'Maintenance Machinist' },
    { name: 'Maintenance Mechanic Welder' },
    { name: 'Makeup Artist' },
    { name: 'Makeup Artists, Theatre and Performance' },
    { name: 'Makeup Product Developer' },
    { name: 'Male Barber' },
    { name: 'Male Bartender' },
    { name: 'Male Fashion Tailor' },
    { name: 'Male General Surgeon' },
    { name: 'Male Infertility Urologist' },
    { name: 'Male Model' },
    { name: 'Male Nanny' },
    { name: 'Management Accountant' },
    { name: 'Manager' },
    { name: 'Manufacturing Engineer' },
    { name: 'Manufacturing Production Workers' },
    { name: 'Mapping Technician' },
    { name: 'Marble & Tile Cleaner' },
    { name: 'Marble Installer' },
    { name: 'Marine Bilogist' },
    { name: 'Marine Biologist' },
    { name: 'Marine Drafter' },
    { name: 'Marine Electrician' },
    { name: 'Marine Engineer' },
    { name: 'Marine Lawyer' },
    { name: 'Marine Pipe Fitter' },
    { name: 'Marine Reporters' },
    { name: 'Marine Researcher' },
    { name: 'Marine Scientist' },
    { name: 'Marine Surveyor' },
    { name: 'Marine Workers' },
    { name: 'Marine/Water Engineer' },
    { name: 'Market Intelligence Analyst' },
    { name: 'Market Research Administrator' },
    { name: 'Market Research Executive' },
    { name: 'Market Research Intern' },
    { name: 'Market Researchers and Analysts' },
    { name: 'Marketing Copywriter' },
    { name: 'Marketing Manager' },
    { name: 'Marketing Specialist' },
    { name: 'Marriage & Family Therapist' },
    { name: 'Mason' },
    { name: 'Massage Therapist' },
    { name: 'Master Braider' },
    { name: 'Master Planner' },
    { name: 'Master Precision Hair Cutter' },
    { name: 'Material Engineer' },
    { name: 'Material Sculptor' },
    { name: 'Materials Sculptor' },
    { name: 'Mathematical Data Scientist' },
    { name: 'Mathematical Science' },
    { name: 'Mathematical Science Occupations' },
    { name: 'Mathematical Technician' },
    { name: 'Mathematician' },
    { name: 'Meat Packager' },
    { name: 'Meat Packer' },
    { name: 'Meat Scientist' },
    { name: 'Mechanic' },
    { name: 'Mechanical Assembler' },
    { name: 'Mechanical Door Repairer' },
    { name: 'Mechanical Drafter' },
    { name: 'Mechanical Engineer' },
    { name: 'Mechanical Pipe Fitter' },
    { name: 'Mechanical/Electrical Gate Installer' },
    { name: 'Mechanized Meat Cutter ' },
    { name: 'Mechatronics Engineer' },
    { name: 'Media and Communication Equipment Workers' },
    { name: 'Media and Communication Workers' },
    { name: 'Media Announcer' },
    { name: 'Media Art Director' },
    { name: 'Media Author' },
    { name: 'Media Correspondence' },
    { name: 'Media Graphic Designer' },
    { name: 'Media Interpreter' },
    { name: 'Media Interpreter/Translator' },
    { name: 'Media Photographer' },
    { name: 'Media Reporter' },
    { name: 'Media scriptwriter' },
    { name: 'Mediator' },
    { name: 'Medical and Clinical Laboratory Technologists/Technicians' },
    { name: 'Medical Courier' },
    { name: 'Medical Doctor' },
    { name: 'Medical Equipment Installer' },
    { name: 'Medical Facilities Tour Guide' },
    { name: 'Medical Illustrator' },
    { name: 'Medical Interpreter' },
    { name: 'Medical Laboratory Technician' },
    { name: 'Medical Librarian' },
    { name: 'Medical Malpractice Lawyer' },
    { name: 'Medical Records Technician' },
    { name: 'Medical Secretary' },
    { name: 'Medical Technologist' },
    { name: 'Meeting and Convention Planners' },
    { name: 'Meeting Coordination' },
    { name: 'Memoirist' },
    { name: "Men's Makeup Expert" },
    { name: "Men's Skin Care Specialist" },
    { name: "Men's Surgeon" },
    { name: "Men's Tailor" },
    { name: 'Mental Care Nurse' },
    { name: 'Mental Health Counselor' },
    { name: 'Mental Health Nurse' },
    { name: 'Mental Health Worker' },
    { name: 'Mental Health Workers' },
    { name: 'Metal & Plastic Mold Maker' },
    { name: 'Metal Craft Artist' },
    { name: 'Metal Drummer' },
    { name: 'Metal Molding Machine Operator' },
    { name: 'Metal Polisher' },
    { name: 'Metal Sculptor ' },
    { name: 'Metal Scupltor' },
    { name: 'Mezzo Soprano Singer' },
    { name: 'Microbiologists' },
    { name: 'Microsystem Engineer' },
    { name: 'Milk Packaging Operator' },
    { name: 'Minerals Surveyor' },
    { name: 'Mining Machine Operator' },
    { name: 'Mixing & Blending Machine Operator' },
    { name: 'Mixologist' },
    { name: 'Mobile Application Developer' },
    { name: 'Mobile Device Photographer/Videographer' },
    { name: 'Mobile Intensive Care Ambulance (MICA) Paramedic' },
    { name: 'Model and Mold Makers' },
    { name: 'Modelling Sculptor' },
    { name: 'Models' },
    { name: 'Mold Designer & Engineer' },
    { name: 'Morticians' },
    { name: 'Mortuary Attendant' },
    { name: 'Mortuary Scientist' },
    { name: 'Motion Graphic Illustrator' },
    { name: 'Motion Graphics Designer' },
    { name: 'Motion Picture Camera Operator' },
    { name: 'Motor Vehicle Inspectors' },
    { name: 'Movie & Musical Set Tour Guide' },
    { name: 'Movie (Actor/Actress)' },
    { name: 'Movie Cameraman' },
    { name: 'Movie Industry Marketer' },
    { name: 'Movie Sports Agent' },
    { name: 'Movie/Film Gaffer' },
    { name: 'Multimedia Artist & Animator' },
    { name: 'Multimedia Artists and Animators ' },
    { name: 'Multimedia Specialist' },
    { name: 'Mural painter' },
    { name: 'Museum Curator' },
    { name: 'Museum Officer' },
    { name: 'Music Agent' },
    { name: 'Music Arranger' },
    { name: 'Music Composer' },
    { name: 'Music Directing Expert' },
    { name: 'Music Director' },
    { name: 'Music Librarian' },
    { name: 'Music Manager' },
    { name: 'Music Orchestrator' },
    { name: 'Music Teacher' },
    { name: 'Music Therapist' },
    { name: 'Musical Director' },
    { name: 'Musical Instrument Repairer' },
    { name: 'Musical Video Choreographer' },
    { name: 'Musical Video Dancer' },
    { name: 'Musician Instrumentalists' },
    { name: 'Musicians and Singers ' },
    { name: 'Mycologist' },
    { name: 'Nail Technician' },
    { name: 'Nanosystems Engineer' },
    { name: 'Narrator & Voice Over Artist' },
    { name: 'Natural Hair Care Specialist' },
    { name: 'Neonatal ICU Nurse' },
    { name: 'Nephrologist' },
    { name: 'Network Engineer' },
    { name: 'Neurological Physical Therapist' },
    { name: 'Neurologist' },
    { name: 'Neurology Doctor' },
    { name: 'Neurophysiologist' },
    { name: 'Neurosurgeon' },
    { name: 'News Anchor' },
    { name: 'Newspaper & Magazine Advert Marketer' },
    { name: 'Nigerian Heritage Historian' },
    { name: 'Novelist' },
    { name: 'Nuclear Engineer' },
    { name: 'Nuclear Medicine Physician' },
    { name: 'Nuclear Pharmacist' },
    { name: 'Nuclear Technician' },
    { name: 'Nurse Anaesthetics Assistant' },
    { name: 'Nurse Anaesthetist' },
    { name: 'Nurse Assistant' },
    { name: 'Nurse Educator' },
    { name: 'Nurse Manager/Administrator' },
    { name: 'Nurse Midwife' },
    { name: 'Nurse Practitioner' },
    { name: 'Nurses' },
    { name: 'Nursing Aide' },
    { name: 'Nursing Assistant' },
    { name: 'Nursing Educator' },
    { name: 'Nursing Midwife' },
    { name: 'Nursing Orderlies' },
    { name: 'Nursing Orderly' },
    { name: 'Nursing Teacher' },
    { name: 'Nursing Unit Clerk' },
    { name: 'Nutrition Educator' },
    { name: 'Nutritionist' },
    { name: 'Nutritionist Therapist' },
    { name: 'Nuts & Bolts Assemblers' },
    { name: 'Nylon Upholsterer' },
    { name: 'OAP (On Air Personality)' },
    { name: 'Obesity Surgeon' },
    { name: 'Obstetric & Gynaecological Surgeon' },
    { name: 'Obstetrician' },
    { name: 'Obstetrician & Gynaecologist' },
    { name: 'Occupational Therapist' },
    { name: 'Ocean Engineer' },
    { name: 'Oculoplastic Surgeon' },
    { name: 'Off Shore Pipe  Fitter' },
    { name: 'Office Cleaner' },
    { name: 'Office Front Desk Officer' },
    { name: 'Office Machines Operator' },
    { name: 'Office Manager' },
    { name: 'Office Receptionist' },
    { name: 'Office Secretary' },
    { name: 'Oil Driller' },
    { name: 'Oil Rig Electrician' },
    { name: 'Okada Repairer' },
    { name: 'On Set Prop Maker' },
    { name: 'On-site Customer Service' },
    { name: 'Onboard Train Engineer' },
    { name: 'Oncology Nurse' },
    { name: 'Oncology Nurse Assistant' },
    { name: 'Oncology Physical Therapist' },
    { name: 'Online Air Travel Agent ' },
    { name: 'Online Delivery Courier' },
    { name: 'Online Editor' },
    { name: 'Online Podcaster' },
    { name: 'Operating Engineer' },
    { name: 'Operations Manager' },
    { name: 'Operations Research Analyst' },
    { name: 'Ophthalmic Surgeon' },
    { name: 'Opthamologist' },
    { name: 'Opthamology Doctor' },
    { name: 'Oral & Maxillofacial Surgeon' },
    { name: 'Oral Surgeon' },
    { name: 'Orgaanist' },
    { name: 'Organ Transplant Surgeon' },
    { name: 'Organic Skin Care Specialist' },
    { name: 'Oriental Caterer' },
    { name: 'Oriental Cuisine Cook' },
    { name: 'Orthopaedic Hand Surgeon' },
    { name: 'Orthopaedic Nurse' },
    { name: 'Orthopaedic Nurse Assistant' },
    { name: 'Orthopaedic Physical Therapist' },
    { name: 'Otolaryngologist (ENT) Surgeon' },
    { name: 'Outdoor Advert Marketer' },
    { name: 'Packaging and Filling Operators' },
    { name: 'Packaging Assistant' },
    { name: 'Packaging Equipment Operator' },
    { name: 'Packaging Machine Operator' },
    { name: 'Packaging/Filling Operator' },
    { name: 'Packers and Packaging Operators ' },
    { name: 'Packing Line Worker' },
    { name: 'Paediatric Care Unit Nurse' },
    { name: 'Paediatric Doctor' },
    { name: 'Paediatric Nurse Assistant' },
    { name: 'Paediatric Nutritionist' },
    { name: 'Paediatric Physical Therapist' },
    { name: 'Paediatric Surgeon' },
    { name: 'Paediatric Urologist' },
    { name: 'Paediatrician' },
    { name: 'Painter' },
    { name: 'Painters and Illustrators ' },
    { name: 'Painting& Spraying Machine Operator' },
    { name: 'Pallbearer' },
    { name: 'Paper Craft Artist' },
    { name: 'Paperback Binder' },
    { name: 'Paraeducator' },
    { name: 'Paralegal' },
    { name: 'Paralegal/Legal Assistants' },
    { name: 'Paramedic Firefighter' },
    { name: 'Parasitologist' },
    { name: 'Parcel Wrapper' },
    { name: 'Park Naturalist' },
    { name: 'Part time/Party Dishwasher' },
    { name: 'Party Caterer' },
    { name: 'Pastry Chef' },
    { name: 'Patent Law & Trade Secrets Paralegal' },
    { name: 'Pathologist' },
    { name: 'Pathology Assistant' },
    { name: 'Pathology Doctor' },
    { name: 'Patient Services Assistant' },
    { name: 'Patrol Guard' },
    { name: 'Pattern Maker' },
    { name: 'Payroll Manager' },
    { name: 'Pencil & Biro Sketch Artist' },
    { name: 'Pencil Sketch Artist' },
    { name: 'Pension Actuarist' },
    { name: 'Perioperative Care Nurse' },
    { name: 'Personal Camera Repairer ' },
    { name: 'Personal Care Aide' },
    { name: 'Personal Care Product Technologist' },
    { name: 'Personal Cosmetologist' },
    { name: 'Personal Delivery Courier' },
    { name: 'Personal Fitness Trainer' },
    { name: 'Personal Home Care Aides' },
    { name: 'Personal Injury Lawyer' },
    { name: 'Personal Nutritionist' },
    { name: 'Personal Services Makeup Artist' },
    { name: 'Pest Control Technician' },
    { name: 'Pest Control Worker/ Assistant' },
    { name: 'Pest Control Workers' },
    { name: 'Pet Photographer' },
    { name: 'Petroleum Discharging Attendant' },
    { name: 'Petroleum Engineer' },
    { name: 'Petroleum Product Trucker' },
    { name: 'Pharmaceutical Epidemiologist' },
    { name: 'Pharmaceutical Scientist' },
    { name: 'Pharmacists' },
    { name: 'Pharmacy Technician' },
    { name: 'Pharmacy Technician Supervisor' },
    { name: 'Philosophy & Religion Teacher' },
    { name: 'Phlebologist' },
    { name: 'Phone Customer Service' },
    { name: 'Photo Duplication Sketch Artist' },
    { name: 'Photo Editor' },
    { name: 'Photo Engraving/Lithographic Machine Operator' },
    { name: 'Photo Journalist' },
    { name: 'Photographer Assistant' },
    { name: 'Photographers' },
    { name: 'Photographic Hand Developer' },
    { name: 'Photographic Process Assistant' },
    { name: 'Photographic Process Workers' },
    { name: 'Photographic Processing Expert' },
    { name: 'Photographic Processing Machine Operator' },
    { name: 'Photographic Reproduction Assistant' },
    { name: 'Photographic Retouch/Restoration Expert' },
    { name: 'Photography Animator' },
    { name: 'Photography Director' },
    { name: 'Photography Expert' },
    { name: 'Photonic Engineer' },
    { name: 'Photonics Technician' },
    { name: 'Photoshop Artist' },
    { name: 'Physical Medicine & Rehabilitation Physician' },
    { name: 'Physical Therapists' },
    { name: 'Physicians and Surgeons ' },
    { name: 'Physics Teacher' },
    { name: 'Physiologists' },
    { name: 'Pianist' },
    { name: 'Piano/Keyboard Repairer' },
    { name: 'Pilot' },
    { name: 'Pipe Fitter Assistant' },
    { name: 'Pipe Fitters' },
    { name: 'Pipe Layer' },
    { name: 'Pipefitter' },
    { name: 'Piping Designer' },
    { name: 'Plane Cabin Crew' },
    { name: 'Plant Breeder' },
    { name: 'Plant Nursery Expert' },
    { name: 'Plant Operator' },
    { name: 'Plant Pathologist' },
    { name: 'Plant Scientist' },
    { name: 'Plant Scientists' },
    { name: 'Plant Technician' },
    { name: 'Plant Toxicologist' },
    { name: 'Plant/ Industrial Security Guard' },
    { name: 'Plasterer' },
    { name: 'Plastic & Reconstruction Surgeon' },
    { name: 'Plastic Molding/Casting Machine Operator' },
    { name: 'Plastic Surgeon' },
    { name: 'Plastic Tooling Engineer' },
    { name: 'Playwright' },
    { name: 'Plumber' },
    { name: 'Plumber Pipe Fitter' },
    { name: 'Plumbers' },
    { name: 'Plus Size Model' },
    { name: 'Podcaster' },
    { name: 'Podiatric Surgeon' },
    { name: 'Podiatrist' },
    { name: 'Poet' },
    { name: 'Pole Dancer' },
    { name: 'Police Matter Lawyer ' },
    { name: 'Political Historian' },
    { name: 'Political Science Taecher' },
    { name: 'Polyester Upholsterer' },
    { name: 'pop Installer' },
    { name: 'Portfolio Manager' },
    { name: 'Portrait Photographer' },
    { name: 'Ports Freight Inspector' },
    { name: 'Postal Clerk' },
    { name: 'Poultry Manager' },
    { name: 'Power-Line Installer & Repairer' },
    { name: 'Pre-purchase Vehicle Inspector' },
    { name: 'Pressers' },
    { name: 'Pressing Machine Operator' },
    { name: 'Preventive Medicine Physician' },
    { name: 'Pricing Actuarist' },
    { name: 'Principal Software Architect' },
    { name: 'Principal Software Engineer' },
    { name: 'Printing Machine Operator' },
    { name: 'Prison Cook' },
    { name: 'Private and Investigators and Detectives ' },
    { name: 'Private Butcher' },
    { name: 'Private Detective' },
    { name: 'Private Highclass Cook' },
    { name: 'Private Investigator' },
    { name: 'Private Legal Secretary' },
    { name: 'Private Secretary' },
    { name: 'Probation Officer' },
    { name: 'Proctologist' },
    { name: 'Producer' },
    { name: 'Producers/Directors  ' },
    { name: 'Product Designer' },
    { name: 'Product Illustrator' },
    { name: 'Production & Packaging Technician' },
    { name: 'Production Assembler/Line Operator' },
    { name: 'Production Assembly Operator' },
    { name: 'Production Assistant' },
    { name: 'Production Costume Designer' },
    { name: 'Production Designer' },
    { name: 'Production Director' },
    { name: 'Production Hair Stylist' },
    { name: 'Production Helpers' },
    { name: 'Production Location Manager' },
    { name: 'Production Manager' },
    { name: 'Production Music Writer' },
    { name: 'Production Scenic Artist' },
    { name: 'Production Sound Mixers' },
    { name: 'Production Supervisor' },
    { name: 'Production Transportation Driver' },
    { name: 'Production Wardrobe Stylist' },
    { name: 'Professional Camera Repairer' },
    { name: 'Professional Speaker' },
    { name: 'Program Coordinator' },
    { name: 'Project Accountant' },
    { name: 'Project Manager' },
    { name: 'Proof Reader Editor' },
    { name: 'Prop Maker' },
    { name: 'Psychiatric Doctor' },
    { name: 'Psychiatrist' },
    { name: 'Psychiatrist Nurse ' },
    { name: 'Psychology Teacher' },
    { name: 'Public Advocacy Lawyer' },
    { name: 'Public Health Nurse' },
    { name: 'Public Health Nurse Assistant' },
    { name: 'Public Health Nutitionist' },
    { name: 'Public Librarian' },
    { name: 'Public Relations Director' },
    { name: 'Public Relations Manager' },
    { name: 'Public service Attorney' },
    { name: 'Pulmonologist' },
    { name: 'Quality  Control Manager' },
    { name: 'Quantity Surveyor' },
    { name: 'R & B Musician' },
    { name: 'R & D Manager' },
    { name: 'Radio and TV Announcers' },
    { name: 'Radio Broadcaster' },
    { name: 'Radio Operator' },
    { name: 'Radio Presenter' },
    { name: 'Radio Repairer' },
    { name: 'Radiologic Technician' },
    { name: 'Radiologic Technologist' },
    { name: 'Radiologist' },
    { name: 'Radiology Doctor' },
    { name: 'Radios & Podcasts Advert Marketer' },
    { name: 'Ragga Musician' },
    { name: 'Rail Equipment Operator' },
    { name: 'Rail Freight Forwarder' },
    { name: 'Rail Labourer' },
    { name: 'Rail Road Signal Maintainer' },
    { name: 'Rail Track Inspector' },
    { name: 'Rail-Track Maintenance Machine Operator' },
    { name: 'Rat & Rodent Exterminator' },
    { name: 'Ratings Analyst' },
    { name: 'Real Estate Agent' },
    { name: 'Real Estate Appraiser' },
    { name: 'Real Estate Broker' },
    { name: 'Real Estate Brokers/Agents' },
    { name: "Real Estate Buyer's Agent" },
    { name: 'Real Estate Dual Agent' },
    { name: 'Real Estate Lawyer' },
    { name: 'Real Estate Paralegal' },
    { name: "Real Estate Seller's Agent" },
    { name: 'Real MVP' },
    { name: 'Realist Sketch Artist' },
    { name: 'Realtor' },
    { name: 'Receptionist' },
    { name: 'Receptionist (Administrative Services Manager)' },
    { name: 'Receptionists and Information Clerks' },
    { name: 'Recreation & Fitness Studies Teacher' },
    { name: 'Recreation Officer' },
    { name: 'Refrigeration & Air-conditioning Installer' },
    { name: 'Refrigeration & Air-conditioning Repairer' },
    { name: 'Refrigeration Pipe Fitter' },
    { name: 'Reggae Musician' },
    { name: 'Registered Nurse' },
    { name: 'Religious Program Director' },
    { name: 'Remote Sensing Technician' },
    { name: 'Renewable Energy Engineer' },
    { name: 'Research & Advisory Analyst' },
    { name: 'Research Mathematician' },
    { name: 'Research Paper Translator' },
    { name: 'Research Veterinarian' },
    { name: 'Reservation Agent' },
    { name: 'Reserve Firefighter' },
    { name: 'Residential Architect' },
    { name: 'Residential Councelor' },
    { name: 'Residential Electrician' },
    { name: 'Residential Plumber' },
    { name: 'Restaurant & Bukateria Caterer' },
    { name: 'Restaurant Dishwasher' },
    { name: 'Restaurant/Eatery Cook' },
    { name: 'Restroom Attendant' },
    { name: 'Retail Pharmacist' },
    { name: 'Retail Sales Clerk' },
    { name: 'Rheumatologist' },
    { name: 'Rhinoplastic Surgeon' },
    { name: 'Ride-Hailing Driver' },
    { name: 'Risk & Insurance Manager' },
    { name: 'Risk Advisor' },
    { name: 'Risk Analyst' },
    { name: 'Road Freight Forwarder' },
    { name: 'Road Grader Driver' },
    { name: 'Robotics Technician' },
    { name: 'Rock Drill Operator' },
    { name: 'Rolling Machine Operator' },
    { name: 'Roofer' },
    { name: 'Roofing & Frame Carpenter' },
    { name: 'Room Attendant' },
    { name: 'Rope Tier' },
    { name: 'Rotary Engraver' },
    { name: 'Rugby Referee' },
    { name: 'Runway Model' },
    { name: 'Safe, Vault & Strong Room Installer' },
    { name: 'Sale Manager' },
    { name: 'Sales & Event Coordination' },
    { name: 'Sales Specialist' },
    { name: 'Sandwich Wrapper' },
    { name: 'Sanitary Plumber' },
    { name: 'Satirical Cartoonist' },
    { name: 'Satirist' },
    { name: 'Sausage Stringer' },
    { name: 'Saw Filer' },
    { name: 'Saw Mill Worker' },
    { name: 'Saw Miller' },
    { name: 'Sawing Machine Operator' },
    { name: 'Saxophonist' },
    { name: 'Scaffold Erector' },
    { name: 'Scaffolder Labourer' },
    { name: 'Scanner Machine Operator' },
    { name: 'Scenic Carpenter' },
    { name: 'Scenic/Set Carpenter' },
    { name: 'School Administrator' },
    { name: 'School Caterer' },
    { name: 'School Cleaner' },
    { name: 'School Coach' },
    { name: 'School Cook' },
    { name: 'School Councelor' },
    { name: 'School Excursion Tour Guide' },
    { name: 'School Feeding Program Caterer' },
    { name: 'School Janitor' },
    { name: 'School Librarian' },
    { name: 'School Photographer' },
    { name: 'School Principal' },
    { name: 'School Psychologist' },
    { name: 'School Security Guard' },
    { name: 'Science Lecturer' },
    { name: 'Scorekeeper' },
    { name: 'Scraper Operator' },
    { name: 'Screenwriter' },
    { name: 'Script Writer' },
    { name: 'Scriptwriter' },
    { name: 'Scuba Diving Instructor' },
    { name: 'Sculptors' },
    { name: 'Sea Freight Forwarder' },
    { name: 'Sea Travel Agent' },
    { name: 'Seaman' },
    { name: 'Secondary School Teaching Assistant' },
    { name: 'Secretaries' },
    { name: 'Secretary (Administrative Worker)' },
    { name: 'Section Curator' },
    { name: 'Security Escort' },
    { name: 'Security Guards' },
    { name: 'Self Enrichment Teacher' },
    { name: 'Senior Food Technologist' },
    { name: 'Sensory Scientist' },
    { name: 'SEO Copywriter' },
    { name: 'Service & Repair Plumber' },
    { name: 'Service Judge' },
    { name: 'Session Singer' },
    { name: 'Set Caterer' },
    { name: 'Set Construction Builder' },
    { name: 'Set Decorator' },
    { name: 'Set Decorator/Dresser' },
    { name: 'Settee Designer' },
    { name: 'Sheet Metal Worker' },
    { name: 'Ship and Boat carpenter' },
    { name: 'Ship Captain' },
    { name: 'Shipper' },
    { name: 'Shipping Agent' },
    { name: 'Shipping Broker' },
    { name: 'Shoe Designer' },
    { name: 'Shoe Making Machine Operator' },
    { name: 'Shoe Packer' },
    { name: 'Short Story Writer' },
    { name: 'Shrimp Packer' },
    { name: 'Sightseeing Tour Guide' },
    { name: 'Sign Language Interpreter' },
    { name: 'Sign Language Performer' },
    { name: 'Sign Language Teacher' },
    { name: 'Silk Upholsterer' },
    { name: 'Silk/Satin Upholsterer' },
    { name: 'Singers' },
    { name: 'Singing Performer' },
    { name: 'Sketch Artists' },
    { name: 'Skin Care Consultant' },
    { name: 'Skin Care Product Specialist' },
    { name: 'Skin Care Specialists' },
    { name: 'Small Animal Practitioner' },
    { name: 'Small Chops Caterer' },
    { name: 'Small Chops Specialist' },
    { name: 'Small Engine Mechanic' },
    { name: 'Smart TV Installer/ Technician' },
    { name: 'Smartwatch Repairer' },
    { name: 'Social and Community Service Workers' },
    { name: 'Social Critic' },
    { name: 'Social Media Customer Service' },
    { name: 'Social Media Marketer' },
    { name: 'Social Media Writer' },
    { name: 'Social Sciences Teacher' },
    { name: 'Social Service Worker' },
    { name: 'Social Worker' },
    { name: 'Softball Umpire' },
    { name: 'Software Architect' },
    { name: 'Software Engineer' },
    { name: 'Software Engineering Expert' },
    { name: 'Soil Scientist' },
    { name: 'Solar Energy Engineer' },
    { name: 'Soprano Singer' },
    { name: 'Sound Editor' },
    { name: 'Sound Engineering Expert' },
    { name: 'Soups & Stews Caterer' },
    { name: 'Sous Chef' },
    { name: 'Spa Attendant' },
    { name: 'Spa Owner' },
    { name: 'Spa/Salon Workers' },
    { name: 'Special & Vocational Education Teacher' },
    { name: 'Special Collections Curator' },
    { name: 'Special Collections Librarian' },
    { name: 'Special Effects Coordinator' },
    { name: 'Special Effects Makeup Artist' },
    { name: 'Special Events Director' },
    { name: 'Special Needs Child Carer' },
    { name: 'Special Needs Specialist' },
    { name: 'Specialist Actuary' },
    { name: 'Specialist Courier' },
    { name: 'Speciality Photographer' },
    { name: 'Specialized menu Caterer' },
    { name: 'Specialty Veterinarian' },
    { name: 'Speech Pathologist' },
    { name: 'Speechwriter' },
    { name: 'Sports Administrator' },
    { name: 'Sports Coach' },
    { name: 'Sports Commentator' },
    { name: 'Sports Manager' },
    { name: 'Sports medicine Physician' },
    { name: 'Sports Nutritionist' },
    { name: 'Sports Photographer' },
    { name: 'Sports Physical Therapist' },
    { name: 'Sports Trainer' },
    { name: 'Squash Umpire' },
    { name: 'Staff Accountant' },
    { name: 'Staff Assistant' },
    { name: 'Stage Dance Choreographer' },
    { name: 'Stage Designer' },
    { name: 'Stage Manager' },
    { name: 'Stage Perfomer' },
    { name: 'Stainless Steel Fabricator' },
    { name: 'State correctional Manager' },
    { name: 'State Government Revenue Collector' },
    { name: 'State Schools Superintendent' },
    { name: 'Static Security Guard' },
    { name: 'Statistician' },
    { name: 'Steam Fitter' },
    { name: 'Steel Fabricator' },
    { name: 'Stone Sculptor' },
    { name: 'Stop Motion Animator' },
    { name: 'Store Detective' },
    { name: 'Storyboard Artist' },
    { name: 'Storyboard Illustrator' },
    { name: 'Street Cleaner' },
    { name: 'Structural Engineer' },
    { name: 'Structural Iron and Steel Workers' },
    { name: 'Structural Steel Erector' },
    { name: 'Structural Steel Layout Fitter' },
    { name: 'Student Ministry Director' },
    { name: 'Studio Photographer' },
    { name: 'Stunt Coordinator' },
    { name: 'Stunt Performer' },
    { name: 'Stunt Person' },
    { name: 'Substance Abuse Councelor ' },
    { name: 'Substance Abuse Counseling Expert' },
    { name: 'Substance Abuse Counsellor' },
    { name: 'Substance Abuse Counselor' },
    { name: 'Substation Electrician' },
    { name: 'Supply Chain Manager' },
    { name: 'Surgeon' },
    { name: 'Surgeons' },
    { name: 'Surgical ICU Nurse' },
    { name: 'Surgical Nurse' },
    { name: 'Surgical Nursing Assistant' },
    { name: 'Surgical Technologist' },
    { name: 'Surveyors' },
    { name: 'Suspended Ceiling Installer' },
    { name: 'Swimming Judge' },
    { name: 'Swimming Pool Maintainer' },
    { name: 'Systems Analyst' },
    { name: 'Systems Engineer Analyst' },
    { name: 'Systems Network Engineer' },
    { name: 'Table Tennis Umpire' },
    { name: 'Taekwondo Trainer' },
    { name: 'Tailor' },
    { name: 'Tailors, Dressmakers and Custom Sewers ' },
    { name: 'Talent Scout' },
    { name: 'Tattoo Illustrator' },
    { name: 'Tax Auditor' },
    { name: 'Tax Collector' },
    { name: 'Tax Economist' },
    { name: 'Tax Examiner' },
    { name: 'Tax Examiners, Collectors and Revenue Agents ' },
    { name: 'Tax Investigator' },
    { name: 'Tax Lawyer' },
    { name: 'Taxi Cab Driver' },
    { name: 'Taxi Drivers and Chauffeurs' },
    { name: 'Teacher Assistants' },
    { name: 'Teachers, Secondary/Post-secondary' },
    { name: 'Teaching Psychologist' },
    { name: 'Technical & Engineering Illustrator' },
    { name: 'Technical Designer' },
    { name: 'Technical Director' },
    { name: 'Technical Illustrator' },
    { name: 'Technical Officer' },
    { name: 'Technical Writer' },
    { name: 'Technicians' },
    { name: 'Telecommunication Specialist' },
    { name: 'Teleprompter' },
    { name: 'Television (Actor/Actress)' },
    { name: 'Television Advert Marketer' },
    { name: 'Television Broadcaster' },
    { name: 'Television Camera Operator' },
    { name: 'Television Editor' },
    { name: 'Television Floor Manager' },
    { name: 'Television Makeup Artist' },
    { name: 'Television Program Director' },
    { name: 'Television Studio Editor' },
    { name: 'Tenor Singer' },
    { name: 'Textile & Garment Presser' },
    { name: 'Textile Artist' },
    { name: 'Textile Winding/Twisting Machine Operator' },
    { name: 'Theater Consultant' },
    { name: 'Theater Makeup Artist' },
    { name: 'Theater Manager' },
    { name: 'Theoretical Economist' },
    { name: 'Therapist' },
    { name: 'Ticketing Officer' },
    { name: 'Toning & Skin Brightening Expert' },
    { name: 'Tool & Die Maker' },
    { name: 'Tool Grinder' },
    { name: 'Tool Grinder, Filer and Sharpeners' },
    { name: 'Tool Model Maker' },
    { name: 'Tool Sharpener' },
    { name: 'Tour Bus Guide' },
    { name: 'Tour Guides and Escorts' },
    { name: 'Tourist Courier' },
    { name: 'Tourist Guide' },
    { name: 'Town Planner' },
    { name: 'Toy Packer' },
    { name: 'Tractor Driver' },
    { name: 'Traditional Religion Educator ' },
    { name: 'Traffic Technician' },
    { name: 'Trailer Driver' },
    { name: 'Train Chef' },
    { name: 'Train Coach Attendant' },
    { name: 'Train Conductor' },
    { name: 'Train Crew Members' },
    { name: 'Train Engineer' },
    { name: 'Train Fireman' },
    { name: 'Train Master' },
    { name: 'Train Service Attendant' },
    { name: 'Trainman' },
    { name: 'Transplant Surgeon' },
    { name: 'Transport Caterer' },
    { name: 'Transportation Engineer' },
    { name: 'Trap Musician' },
    { name: 'Trauma & Orthopaedic Surgeon' },
    { name: 'Travel Agency Clerk' },
    { name: 'Travel Agents' },
    { name: 'Travel Guide' },
    { name: 'Treasury & Finance  Officer' },
    { name: 'Trichologist' },
    { name: 'Tricycle response Paramedic' },
    { name: 'Truck Drivers' },
    { name: 'Trumpetist' },
    { name: 'TV & Video Repairer' },
    { name: 'TV Anchor' },
    { name: 'TV Marketing Executive' },
    { name: 'TV Presenter' },
    { name: 'TV Producer' },
    { name: 'TV Program Host' },
    { name: 'TV Talk Show Host' },
    { name: 'TV Technical Director' },
    { name: 'TV Weather Presenter' },
    { name: 'Two-Wheeler Repairers' },
    { name: 'Tyre Sculptor' },
    { name: 'UI/UX Design Manager' },
    { name: 'UI/UX Designer' },
    { name: 'Ultrasound Technician' },
    { name: 'Umpires, Referees, and Other Sports Officials' },
    { name: 'Undercover Guard' },
    { name: 'Undergraduate Teaching Assistant' },
    { name: 'Underwater Cinematographer' },
    { name: 'University Recruiter' },
    { name: 'Upholsterers' },
    { name: 'Urban and Regional Planners' },
    { name: 'Urban Planner' },
    { name: 'Urologic Oncologist' },
    { name: 'Urologist' },
    { name: 'Urologists' },
    { name: 'Urology Doctor' },
    { name: 'User Management Administrator ' },
    { name: 'Utility Surveyor' },
    { name: 'UX Designer' },
    { name: 'Valuation Surveyor' },
    { name: 'Vascular Physician' },
    { name: 'Vascular Surgeon' },
    { name: 'Vaulted & Cathedral Ceiling Installer ' },
    { name: 'Vector & Illustration Designer' },
    { name: 'Vegetable Packer' },
    { name: 'Vestibular Physical Therapist' },
    { name: 'Vet Doctor' },
    { name: 'Veterinarians' },
    { name: 'Veterinary Assistant' },
    { name: 'Veterinary Researcher' },
    { name: 'Veterinary Technician/Technologist' },
    { name: 'Video Editor' },
    { name: 'Video Equipment (Technician)' },
    { name: 'Video Game Content Designer' },
    { name: 'Video Game Creetive Director' },
    { name: 'Video Game Design Director' },
    { name: 'Video Game Designer' },
    { name: 'Video Game Designers' },
    { name: 'Video Game Entry Level Designer' },
    { name: 'Video Game Lead Animator' },
    { name: 'Video Game Lead Designer' },
    { name: 'Video Game Senior Level Designer' },
    { name: 'Video Game System Designer' },
    { name: 'Video Game Technical Designer' },
    { name: 'Video Game Usability Expert' },
    { name: 'Video Game User Interface Designer' },
    { name: 'Video Vixen' },
    { name: 'Videographer' },
    { name: 'Videographer Assistant' },
    { name: 'Violinist' },
    { name: 'Virologist' },
    { name: 'Voice Actor' },
    { name: 'Volleyball Tennis Umpire' },
    { name: 'Volunteer Firefighter' },
    { name: 'Volunteer Guide' },
    { name: 'Wakanow Agent' },
    { name: 'Wall Screed Expert' },
    { name: 'Ward Clerk' },
    { name: 'Wardrobe Designer' },
    { name: 'Warehouse Courier' },
    { name: 'Warehouse Worker' },
    { name: 'Watch Repairer' },
    { name: 'Water Engineer' },
    { name: 'Water Polo Official ' },
    { name: 'Water Supply Plumber' },
    { name: 'Wax Specialist' },
    { name: 'Weavologist' },
    { name: 'Web Designer' },
    { name: 'Web Designer & Developer' },
    { name: 'Web Developer' },
    { name: 'Web Specialist' },
    { name: 'Wedding & Special Occasion Tailor' },
    { name: 'Wedding Caterer' },
    { name: 'Wedding Photographer' },
    { name: 'Wedding/Party Planner' },
    { name: 'Weed Scientist' },
    { name: 'Weight Management Consultant' },
    { name: 'Welder' },
    { name: 'Welder Trainee' },
    { name: 'Welder/Pipe Fitter' },
    { name: 'Welding Machine Operator' },
    { name: 'Welfare Worker' },
    { name: 'Wheel Grinder' },
    { name: 'Wigmaker' },
    { name: 'Wilderness Response Paramedic' },
    { name: 'Wildland Firefighter' },
    { name: 'Wildlife Rehabilator' },
    { name: 'Wildlife Veterinarian' },
    { name: 'Wind Energy Engineer' },
    { name: 'Window Cleaner' },
    { name: 'Women & Antenatal Surgeon' },
    { name: "Women's Health Physical Therapist" },
    { name: "Women's Tailor" },
    { name: 'Wood Craft Artist' },
    { name: 'Wood Flooring Installer' },
    { name: 'Wood Model Maker' },
    { name: 'Wood Sawing Machine Operator' },
    { name: 'Wood Sculptor' },
    { name: 'Wood Working Machine Operator' },
    { name: 'Wooden & Coffered Ceiling Installer' },
    { name: "Workers' Claims & Compensation Lawyer" },
    { name: 'Wrapping Clerks' },
    { name: 'Wrestling Referee' },
    { name: 'Writers and Authors ' },
    { name: 'Yam Packers' },
    { name: 'Yoga Instructor' },
    { name: 'Yoruba Teacher' },
    { name: 'Youth Counselor' },
    { name: 'Youth Leader' },
    { name: 'Youth Minister' },
    { name: 'Youth Worker' },
    { name: 'YouTube Broadcaster' },
    { name: 'YouTube Choreographer' },
    { name: 'YouTube Performer' },
    { name: 'Zoo Educator' },
    { name: 'Zookeeper' },
    { name: 'Zoologist' },
    { name: 'Zoologists and Biologists ' }
];
